import ScrollToErrorMixin         from '../../../../support/scroll_to_error_mixin'
import SimpleAssessmentController from '../../simple_assessment_controller'
import SmokingHabitsMixin         from '../../../medical_histories/smoking_habits_mixin'
import BloodPressureCheckMixin    from '../../../../support/blood_pressure_check_mixin'
import BmiMixin                   from '../../../../support/bmi_mixin'
import GlucoseIndicatorMixin      from '../../../../support/glucose_indicator_mixin'
import mixin                      from '../../../../support/mixin'

export default class extends mixin(
  SimpleAssessmentController,
  BmiMixin,
  BloodPressureCheckMixin,
  ScrollToErrorMixin,
  SmokingHabitsMixin,
  GlucoseIndicatorMixin
) {

  // ==== Controllers

  // ==== Actions

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
